import type { Components } from '@mui/material/styles';

export default function MUISpeedDialIcon(): Components['MuiSpeedDialIcon'] {
  return {};
}
